import React from "react";

/**
 * Modale de confirmation générique (remplace window.confirm()).
 * Calquée sur le pattern déjà utilisé dans StatutTimeline.js (Flotte).
 */
const ConfirmModal = ({
  isOpen,
  title = "Confirmation",
  message,
  items = [],
  itemsLabel = null,
  confirmLabel = "Confirmer",
  cancelLabel = "Annuler",
  isLoading = false,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={onCancel}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fas fa-info-circle text-primary mr-2"></i>
              {title}
            </h5>
            <button type="button" className="close" onClick={onCancel}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <p className={items.length > 0 ? "" : "mb-0"}>{message}</p>
            {items.length > 0 && (
              <>
                {itemsLabel && (
                  <p className="mb-1">
                    <strong>{itemsLabel}</strong>
                  </p>
                )}
                <ul className="mb-0 pl-3">
                  {items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              onClick={onCancel}
              disabled={isLoading}
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm}
              disabled={isLoading}
            >
              <i className="fas fa-check mr-1"></i>
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
